import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { route } from '../routes';
import {CheckboxGroup} from "@careers-wales/react-components";

function Question(props) {
    const { t } = useTranslation();


    return (
        <>
            <p><strong> {props.question.category}</strong></p>
            <p> {props.question.instructions}</p>

        <CheckboxGroup
            groupClasses={['checkboxes--custom-d', 'no-legend']}
            id={"question_" + props.currentStage}
            key={props.currentStage}
            label={props.question.pageTitle}
            options={
                props.question.answers.map((item) => {
                    return {
                        "id": item.dmqResponseId,
                        "text": item.response
                    }
                })
            }
            value={props.answers[props.currentStage]}
            onChange={(value) => {
                if (value.length <= 2) {
                    props.setValidationError(false);
                    let existingAnswers = [...props.answers];
                    existingAnswers[props.currentStage]= value;

                    props.setAnswers(existingAnswers);
                } else {
                    props.setValidationError(true);
                }
            }}
        />
        </>
    );
}

export default Question;
